/** Types of assets. Values are lowercase; keys stay PascalCase (see assetTypeToPascalCase for schema-name reconstruction). */
export enum AssetType {
  AffiliateLinkTemplate = 'affiliatelinktemplate',
  Article = 'article',
  ArticleTemplate = 'articletemplate',
  ArticleVersion = 'articleversion',
  BlsItem = 'blsitem',
  CarOffer = 'caroffer',
  Collection = 'collection',
  Comment = 'comment',
  EpgChannel = 'epgchannel',
  EpgBroadcast = 'epgbroadcast',
  EpgBroadcastImageRule = 'epgbroadcastimagerule',
  ErrorItem = 'erroritem',
  FeedConfig = 'feedconfig',
  File = 'file',
  HistoryItem = 'historyitem',
  HoroscopeAngelTarot = 'horoscopeangeltarot',
  HoroscopeAngelTarotDay = 'horoscopeangeltarotday',
  HoroscopeAngelTarotWeek = 'horoscopeangeltarotweek',
  HoroscopeChild = 'horoscopechild',
  HoroscopeDay = 'horoscopeday',
  HoroscopeGuardianAngelMessage = 'horoscopeguardianangelmessage',
  HoroscopeLove = 'horoscopelove',
  HoroscopeLuckyCharm = 'horoscopeluckycharm',
  HoroscopeMonth = 'horoscopemonth',
  HoroscopeMoonCalendar = 'horoscopemooncalendar',
  HoroscopeMoonRun = 'horoscopemoonrun',
  HoroscopeTarot = 'horoscopetarot',
  HoroscopeTarotDay = 'horoscopetarotday',
  HoroscopeTarotWeek = 'horoscopetarotweek',
  HoroscopeTendencies = 'horoscopetendencies',
  HoroscopeWeek = 'horoscopeweek',
  HoroscopeYear = 'horoscopeyear',
  HotOrNot = 'hotornot',
  ImageDetail = 'imagedetail',
  MenuTerm = 'menuterm',
  Page = 'page',
  Poll = 'poll',
  Profile = 'profile',
  Recipe = 'recipe',
  SearchResultFavorite = 'searchresultfavorite',
  StructureTerm = 'structureterm',
  StructureTermTemplate = 'structuretermtemplate',
  TeaserGroupTemplate = 'teasergrouptemplate',
  Video = 'video',
  VideoChannel = 'videochannel',
  Vod = 'vod'
}

/** Reverse map: lowercase AssetType value -> its PascalCase enum key. */
const assetTypePascalCaseByValue: Record<string, string> = Object.fromEntries(
  Object.entries(AssetType).map(([key, value]) => [value, key])
)

/**
 * Reconstructs the PascalCase name of an AssetType (e.g. 'article' -> 'Article'), needed where the value
 * derives a PascalCase identifier such as a schema name (`${...}AssetSchema`). Falls back to the raw input.
 */
export const assetTypeToPascalCase = (type: AssetType | string): string => assetTypePascalCaseByValue[type] ?? type

/** Types of Articles: documentData.articleType */
export enum ArticleType {
  article = 'article',
  gallery = 'gallery',
  recipe = 'recipe',
  video = 'video'
}

/** Types of StructureTerms: documentData.structureTermType */
export enum StructureTermType {
  author = 'author',
  static = 'static',
  structure = 'structure'
}

/** Types of Pages: documentData.pageType */
export enum PageType {
  asset = 'asset',
  term = 'term'
}
